module.exports = __webpack_public_path__ + "static/undraw_content_vbqo-c5c2689ab326c7ef960bae0b89c3ab42.svg";